import { ArrowDownRight, ArrowUpRight, Minus } from 'lucide-react'

const ICONS = { up: ArrowUpRight, down: ArrowDownRight, flat: Minus }

// How a number moved: the arrow for its direction and the label beside it.
// Every surface that shows a change renders this one, so the glyphs and the
// direction colours (keyed off data-direction in the stylesheet) cannot
// drift between a tile, a card, a funnel step and an expanded headline.
// `change` comes from describeChange; nothing is drawn when it is null.
// `title` is the hover text, for a surface that shows the short form.
export function ChangeIndicator({ change, className, size = 14, text, title, as: Tag = 'span' }) {
  if (!change) return null
  const Icon = ICONS[change.direction]
  return (
    <Tag className={className} data-direction={change.direction} title={title}>
      {Icon ? <Icon size={size} aria-hidden="true" /> : null}
      {text ?? change.label}
    </Tag>
  )
}
